@if (openAssignDialog || confirmDeleteDialog) {
<div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
  <div class="h-full w-full">
    <div
      class="absolute flex flex-col shadow rounded-[16px] bg-white h-fit w-[450px] m-auto bottom-[35%] left-0 right-0 p-5 text-left">
      @if (openAssignDialog) {
      <div>
        <p class="font-bold z-10 mt-3">Assign {{assignRoleDetails?.name}}</p>
        <div class="flex w-full mb-1 input mt-2 border rounded overflow-hidden p-1">
          <fa-icon [icon]="faMagnifyingGlass" [style]="searchIconStyle" />
          <input type="text" class="flex-grow w-full border-0 bg-[#F6F7F8] outline-none text-xs" placeholder="Search"
            [(ngModel)]="searchText" (ngModelChange)="debounceSearch()" />
        </div>
        @if (foundUsers.length > 0) {
        <div class="dropdown shadow w-full flex flex-col overflow-y-auto mt-2">
          @for (user of foundUsers; track user; let i = $index) {
          <button (click)="selectUser(i)"
            [ngClass]="user.isSelected? 'flex flex-row bg-gray-300 rounded-[8px] p-1': 'flex flex-row hover:bg-gray-200 rounded-[8px] p-1'">
            {{user.name}}
          </button>
          }
        </div>
        }
        @if (subjectList.length !== 0 || unitList.length !== 0) {
        <p class="text-sm mt-2">
          You can optionally add the context of this user's role. By default they will have the role's permission system
          wide.
        </p>
        }
        @if (subjectList.length !== 0) {
        <div>
          <p class="mt-3 text-sm">Subjects</p>
          <dropdown-search [items]="subjectList" [addedList]="addedSubjectList" placeholder="Choose subjects" />
          @for (addedSubject of addedSubjectList; track addedSubject) {
          <chip (click)="addedSubjectList = removeItemFromList(addedSubject, addedSubjectList)"
            [text]="addedSubject.name" />
          }
        </div>
        }
        @if (unitList.length !== 0) {
        <div>
          <p class="mt-3 text-sm">Units</p>
          <dropdown-search [items]="unitList" [addedList]="addedUnitList" placeholder="Choose units" />
          @for (addedUnit of addedUnitList; track addedUnit) {
          <chip (click)="addedUnitList = removeItemFromList(addedUnit, addedUnitList)" [text]="addedUnit.name" />
          }
        </div>
        }
        <div class="flex justify-end mt-5">
          <outline-button [marginRight]="true" (click)="cancelAssignDialog()" text="Cancel" />
          <full-button (click)="assignRoleClick()" text="Assign" />
        </div>
      </div>
      }
      @if (confirmDeleteDialog) {
      <div>
        <p class="font-bold mt-3 text-center">Are you sure you want to delete {{roleToDeleteName}}?</p>
        <div class="flex mt-5 justify-end">
          <outline-button text="Cancel" (click)="cancelRoleDeleteDialog()" [marginRight]="true" />
          <full-button text="Confirm" (click)="confirmDeleteRole()" />
        </div>
      </div>
      }
    </div>
  </div>
</div>
}
<breadcrumb endText="User Roles" [navigations]="breadcrumbNavs" />
<div class="m-6">
  <div>
    <div class="flex flex-row justify-between">
      <h1 class="text-neutral-950 text-xl font-semibold leading-10">
        User Roles
      </h1>
      <outline-button [faIcon]="faPlus" text="Add Role" (click)="addRole()" />
    </div>
    <div
      class="grid grid-cols-5 w-full bg-gray-100 rounded-[6px] h-12 text-gray-500 text-xs font-semibold mt-4 text-center px-4 py-2">
      <div class="flex items-center">
        TITLE
      </div>
      <div class="col-span-2 flex items-center">
        ROLE DESCRIPTION
      </div>
      <div class="col-span-2 flex items-center">
        ACTIONS
      </div>
    </div>
    @for (role of roleList; track role; let i = $index) {
    <div>
      <div class="grid grid-cols-5 w-full text-black/90 text-sm px-[16px] py-[8px] h-[48px]">
        <div class="flex items-center">
          {{role.name}}
        </div>
        <div class="col-span-2 flex items-center">
          @if (!canEditDescriptions) {
          <p>
            {{role.description}}
          </p>
          }
          @if (canEditDescriptions) {
          <input #descriptionInput (keydown.enter)="enterDescriptionPress(descriptionInput)"
            (blur)="submitDescription(role.role_id, role.description)" class="editInput"
            [(ngModel)]="role.description" />
          }
        </div>
        <div class="col-span-2 flex items-center gap-[24px]">
          <button (click)="assignDialog(role.role_id, role.name)"
            class="flex items-center gap-[4px] text-[#637381] font-">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M5.616 20C5.17133 20 4.791 19.8417 4.475 19.525C4.159 19.2083 4.00067 18.8287 4 18.386V5.615C4 5.171 4.15833 4.791 4.475 4.475C4.79167 4.159 5.17167 4.00067 5.615 4H10.315C10.2243 3.48933 10.3467 3.02833 10.682 2.617C11.0167 2.20567 11.4593 2 12.01 2C12.5607 2 13.0033 2.20567 13.338 2.617C13.6727 3.02833 13.7883 3.48933 13.685 4H18.385C18.829 4 19.209 4.15833 19.525 4.475C19.841 4.79167 19.9993 5.17167 20 5.615V10.755C20 10.897 19.952 11.016 19.856 11.112C19.76 11.208 19.641 11.256 19.499 11.256C19.357 11.256 19.2383 11.208 19.143 11.112C19.0477 11.016 19 10.8973 19 10.756V5.616C19 5.462 18.936 5.32067 18.808 5.192C18.68 5.06333 18.5387 4.99933 18.384 5H5.616C5.462 5 5.32067 5.064 5.192 5.192C5.06333 5.32 4.99933 5.46133 5 5.616V18.385C5 18.5383 5.064 18.6793 5.192 18.808C5.32 18.9367 5.461 19.0007 5.615 19H10.731C10.8723 19 10.991 19.048 11.087 19.144C11.183 19.24 11.231 19.359 11.231 19.501C11.231 19.643 11.183 19.7617 11.087 19.857C10.991 19.9523 10.8723 20 10.731 20H5.616ZM5 18.007V19V5V11.306V11.231V18.007ZM8 16.269H11.385C11.5263 16.269 11.645 16.221 11.741 16.125C11.837 16.029 11.8847 15.9103 11.884 15.769C11.8833 15.6277 11.8357 15.509 11.741 15.413C11.6463 15.317 11.5273 15.269 11.384 15.269H8C7.858 15.269 7.73933 15.317 7.644 15.413C7.548 15.509 7.5 15.628 7.5 15.77C7.5 15.912 7.548 16.0307 7.644 16.126C7.74 16.2213 7.85867 16.269 8 16.269ZM8 12.5H14.48C14.622 12.5 14.741 12.452 14.837 12.356C14.933 12.26 14.981 12.141 14.981 11.999C14.981 11.857 14.933 11.7383 14.837 11.643C14.741 11.5477 14.6223 11.5 14.481 11.5H8C7.858 11.5 7.73933 11.548 7.644 11.644C7.54867 11.74 7.50067 11.859 7.5 12.001C7.49933 12.143 7.54733 12.2617 7.644 12.357C7.74067 12.4523 7.85933 12.5 8 12.5ZM8 8.73H16C16.142 8.73 16.2607 8.68233 16.356 8.587C16.452 8.491 16.5 8.372 16.5 8.23C16.5 8.088 16.452 7.96933 16.356 7.874C16.26 7.77867 16.1413 7.731 16 7.731H8C7.858 7.731 7.73933 7.779 7.644 7.875C7.54867 7.971 7.50067 8.09 7.5 8.232C7.49933 8.374 7.54733 8.49267 7.644 8.588C7.74067 8.68333 7.85933 8.73067 8 8.73ZM12 4.441C12.2167 4.441 12.396 4.37033 12.538 4.229C12.68 4.08767 12.7507 3.90833 12.75 3.691C12.7493 3.47367 12.6783 3.29467 12.537 3.154C12.3957 3.01333 12.2167 2.94267 12 2.942C11.7833 2.94133 11.6043 3.01233 11.463 3.155C11.3217 3.29767 11.2507 3.47667 11.25 3.692C11.2493 3.90733 11.3203 4.08667 11.463 4.23C11.6057 4.37333 11.7847 4.443 12 4.441ZM18 22.116C16.886 22.116 15.941 21.7277 15.165 20.951C14.3883 20.175 14 19.23 14 18.116C14 17.002 14.3883 16.0567 15.165 15.28C15.9417 14.5033 16.8867 14.1153 18 14.116C19.1133 14.1167 20.0587 14.5047 20.836 15.28C21.6133 16.0553 22.0013 17.0007 22 18.116C22 19.2293 21.612 20.1743 20.836 20.951C20.0587 21.7277 19.1133 22.116 18 22.116ZM17.616 18.5V20.616C17.616 20.718 17.6543 20.8077 17.731 20.885C17.8077 20.9617 17.8973 21 18 21C18.1027 21 18.1927 20.9617 18.27 20.885C18.3473 20.8083 18.3853 20.7183 18.384 20.615V18.5H20.5C20.6027 18.5 20.6927 18.4617 20.77 18.385C20.846 18.3077 20.884 18.2177 20.884 18.115C20.884 18.013 20.8457 17.9233 20.769 17.846C20.6923 17.7693 20.6027 17.731 20.5 17.731H18.384V15.615C18.384 15.513 18.3457 15.4233 18.269 15.346C18.1923 15.2693 18.1027 15.231 18 15.231C17.8973 15.231 17.8073 15.2693 17.73 15.346C17.6527 15.4227 17.6147 15.5127 17.616 15.616V17.731H15.5C15.3973 17.731 15.3073 17.7693 15.23 17.846C15.154 17.9233 15.116 18.0133 15.116 18.116C15.116 18.218 15.1543 18.3077 15.231 18.385C15.3077 18.4617 15.3973 18.5 15.5 18.5H17.616Z"
                fill="#637381" />
            </svg>
            Assign
          </button>
          <button (click)="viewAssignees(role.role_id)" class="flex items-center gap-[4px] text-[#637381] font-">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18" fill="none">
              <path
                d="M2.025 12.046C1.175 10.942 0.75 10.389 0.75 8.75C0.75 7.11 1.175 6.559 2.025 5.454C3.722 3.25 6.568 0.75 10.75 0.75C14.932 0.75 17.778 3.25 19.475 5.454C20.325 6.56 20.75 7.111 20.75 8.75C20.75 10.39 20.325 10.941 19.475 12.046C17.778 14.25 14.932 16.75 10.75 16.75C6.568 16.75 3.722 14.25 2.025 12.046Z"
                stroke="#637381" stroke-width="1.5" />
              <path
                d="M13.75 8.75C13.75 9.54565 13.4339 10.3087 12.8713 10.8713C12.3087 11.4339 11.5456 11.75 10.75 11.75C9.95435 11.75 9.19129 11.4339 8.62868 10.8713C8.06607 10.3087 7.75 9.54565 7.75 8.75C7.75 7.95435 8.06607 7.19129 8.62868 6.62868C9.19129 6.06607 9.95435 5.75 10.75 5.75C11.5456 5.75 12.3087 6.06607 12.8713 6.62868C13.4339 7.19129 13.75 7.95435 13.75 8.75Z"
                stroke="#637381" stroke-width="1.5" />
            </svg>
            View Assignees
          </button>
          <button (click)="editNavigation(role.role_id)" class="flex items-center gap-[4px] text-[#637381] font-">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M17.7586 5.73214L14.268 2.24073C14.1519 2.12463 14.0141 2.03253 13.8624 1.96969C13.7107 1.90685 13.5482 1.87451 13.384 1.87451C13.2198 1.87451 13.0572 1.90685 12.9056 1.96969C12.7539 2.03253 12.6161 2.12463 12.5 2.24073L2.86641 11.8751C2.74983 11.9908 2.65741 12.1284 2.59451 12.2801C2.5316 12.4318 2.49948 12.5945 2.50001 12.7587V16.2501C2.50001 16.5816 2.6317 16.8996 2.86612 17.134C3.10054 17.3684 3.41849 17.5001 3.75001 17.5001H7.24141C7.40563 17.5006 7.5683 17.4685 7.71999 17.4056C7.87168 17.3427 8.00935 17.2503 8.12501 17.1337L17.7586 7.5001C17.8747 7.38403 17.9668 7.24622 18.0296 7.09454C18.0925 6.94286 18.1248 6.7803 18.1248 6.61612C18.1248 6.45194 18.0925 6.28937 18.0296 6.1377C17.9668 5.98602 17.8747 5.84821 17.7586 5.73214ZM7.24141 16.2501H3.75001V12.7587L10.625 5.8837L14.1164 9.3751L7.24141 16.2501ZM15 8.49073L11.5086 5.0001L13.3836 3.1251L16.875 6.61573L15 8.49073Z"
                fill="#637381" />
            </svg>
            Edit
          </button>
          <button (click)="deleteRoleDialog(i)" class="flex items-center gap-[4px] text-[#CC0033] font-">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M7 21C6.45 21 5.97933 20.8043 5.588 20.413C5.19667 20.0217 5.00067 19.5507 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.8043 20.021 18.413 20.413C18.0217 20.805 17.5507 21.0007 17 21H7ZM17 6H7V19H17V6ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z"
                fill="#CC0033" />
            </svg>
            Delete
          </button>
        </div>
      </div>
    </div>
    }
  </div>
</div>